export const nav = {
  discover: "さがす",
  live: "配信",
  chat: "チャット",
  profile: "プロフィール",
  incoming: "着信",
  video: "ビデオ",
  messages: "メッセージ",
  board: "掲示板",
} as const;
